import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100" data-id="element-264" data-mp="1tai2pb8gatrc">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-12" data-id="element-265" data-mp="1t8dqm60eeofz">
        <h2 className="shrink-0 font-serif text-2xl italic leading-tight text-red-700 lg:w-44" data-id="element-266" data-mp="1odhy74r91z2c">
          A teljes csomag számokban
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:mt-0 lg:flex-1 lg:grid-cols-5" data-id="element-267" data-mp="1edr4v6efdq3u">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-slate-900/15 pl-5" data-id="element-268" data-mp="19kxy6czec7p4">
              <dt className="mt-3 text-sm leading-snug text-slate-900/70" data-id="element-269" data-mp="15lfbpcrxfok6">{stat.label}</dt>
              <dd className="font-serif text-6xl leading-none tracking-tight text-slate-900" data-id="element-270" data-mp="10n412ztt5a0w">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}